<template>
    <div class="mk-login-page">
        <div class="mk-login-page-mark" />
        <div class="mk-login-page-form">
            <div class="mk-login-page-title">
                <span>{{ title }}</span>
            </div>
            <div class="mk-login-page-form-logo">
                <img :src="logo">
            </div>
            <div v-if="loading" class="loading-content">
                <van-loading type="spinner" size="24px">登录中...</van-loading>
            </div>
        </div>
    </div>
</template>

<script>
    const mixin = require(`@/config/${process.env.VUE_APP_PROJECT}/login`)
    import { Loading } from 'vant'
    import store from '@/store'

    export default {
        components: {
            [Loading.name]: Loading,
        },
        mixins: [mixin],
        data() {
            return {
                loading: true,
            }
        },
        computed: {
            logo() {
                return require(`@/config/${process.env.VUE_APP_PROJECT}/images/logo.png`)
            },
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                const mkCode = this.$route.query.mkCode
                if (mkCode) {
                    this.mkLogin(mkCode)
                } else {
                    this.$toast({
                        message: '参数错误',
                        position: 'bottom',
                    })
                    setTimeout(() => {
                        this.$router.push({ name: 'Login' })
                    }, 1500)
                }
            },
            mkLogin(mkCode) {
                this.$request.get(
                    '/app/api/unifiedPortal/getAutoLoginInfo',
                    { mkCode },
                    { showLoading: true },
                )
                    .then((res) => {
                        if (res.access_token) {
                            store.commit('setToken', res.access_token)
                            this.$router.push({ name: 'Home' })
                        } else {
                            this.$errorInfo(res.errMessage || '登录失败')
                            setTimeout(() => {
                                this.$router.push({ name: 'Login' })
                            }, 1500)
                        }
                    })
                    .catch(() => {
                        setTimeout(() => {
                            this.$router.push({ name: 'Login' })
                        }, 1500)
                    })
            },
        },
    }
</script>

<style lang="scss">
$background-url: url('../../config/anhui/images/background.png');
.mk-login-page {
  background: $background-url no-repeat;
  background-size: cover;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &-mark {
    border-width: 0px;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(7, 10, 80, 0.5);
    border: none;
    border-radius: 0px;
    box-shadow: none;
  }
  &-title {
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 20px;
  }
  &-form {
    z-index: 1;
    &-logo {
      height: 64px;
      width: 64px;
      border-radius: 10px;
      margin-left: 50%;
      transform: translateX(-50%);
      background: #ffffff;
      margin-bottom: 40px;
      img {
        height: 64px;
        width: 64px;
      }
    }
  }
  .loading-content {
    text-align: center;
    color: #ffffff;
  }
}
</style>
